import {useSelector} from "react-redux";

import AppreciationTabInputText from "../../component/appreciation/AppreciationTabInputText";
import MissingDataIndicator from "../../component/MissingDataIndicator";
import {selectPersistenceInitialized} from "../../redux/persistenceSlice";
import {selectIncomeValueAvailable, selectIncomeValueData, selectLoading} from "../../redux/valueIndicationSlice";
import PersistenceFinalMessage from "../object/PersistenceFinalMessage";
import SnapshotMessage from "../object/SnapshotMessage";
import IndicationTable from "./IndicationTable";

export default function TabIncomeValueIndication() {
    const incomeValueData = useSelector(selectIncomeValueData);
    const incomeValueAvailable = useSelector(selectIncomeValueAvailable);
    const loading = useSelector(selectLoading);
    const persistenceInitialized = useSelector(selectPersistenceInitialized);

    return (
        <>
            <MissingDataIndicator dataAvailable={incomeValueAvailable || loading || !persistenceInitialized} />
            <PersistenceFinalMessage />
            <SnapshotMessage />
            <AppreciationTabInputText page="value" tab="income_value" />
            <IndicationTable endpoint="INCOME_VALUE" indicationDetails={incomeValueData} />
        </>
    );
}
